import $ from './libs/jquery-3.1.1.min';
window.$ = $;
import './libs/jquery.easing';
import jTab from './libs/jquery.j_tab_es';

import Common from './common/common';
import Group from './common/group';
import Business from './common/business';

////

const Init = () => {

	Common();
  Group();
	Business();

}

Init();
